import { FormDetailsProvider } from '../../components/FormDetailsProvider';
import { ProvideDetails } from '../../components/ProvideDetails';
import { useHtmlFormInputs } from '../../hooks/useHtmlFormInputs';

export type FastProvideDetailsFormProps = {
    initial: string;
    errors?: string;
    editmode: string;
};

export function FastProvideDetailsForm({ initial, errors, editmode }: FastProvideDetailsFormProps) {
    const inputs = useHtmlFormInputs();

    return (
        <FormDetailsProvider errors={errors} inputs={inputs}>
            <ProvideDetails initial={initial} editmode={editmode} inputs={inputs} />
        </FormDetailsProvider>
    );
}
